export default __webpack_public_path__ + "static/media/transmit-meter-reading-failed.6dce9146.svg";